import { Link } from 'react-router-dom';
import { LegalLayout } from './LegalLayout';
import { COMPANY, LEGAL_ROUTES } from './legal';

interface SubProcessor {
  name: string;
  purpose: string;
  location: string;
}

/** The third parties that process personal information to help provide Revvly. */
const SUB_PROCESSORS: SubProcessor[] = [
  {
    name: 'Amazon Web Services (AWS)',
    purpose: 'Cloud hosting and database infrastructure',
    location: 'Frankfurt, Germany (EU)',
  },
  {
    name: 'Cloudflare',
    purpose: 'Website delivery, CDN, DNS, and DDoS protection',
    location: 'Global (United States)',
  },
  {
    name: 'SigNoz',
    purpose: 'Application observability and monitoring (logs, traces, metrics)',
    location: 'European Union',
  },
  {
    name: 'Sentry',
    purpose: 'Error and performance monitoring',
    location: 'European Union',
  },
  {
    name: 'Stripe',
    purpose: 'Payment processing',
    location: 'United States',
  },
];

export function SubProcessorsPage() {
  return (
    <LegalLayout
      title="Sub-processors"
      active="subprocessors"
      intro="The third parties we engage to process personal information on our behalf when providing Revvly."
    >
      <p>
        We use the sub-processors listed below to help us provide, secure, and operate Revvly. Each is
        bound by contract to protect personal information and to process it only for the purposes we
        specify. This page complements our <Link to={LEGAL_ROUTES.privacy}>Privacy Policy</Link>; we
        will update it before adding or replacing a sub-processor.
      </p>

      <div className="legal__table-wrap">
        <table className="legal__table">
          <thead>
            <tr>
              <th>Sub-processor</th>
              <th>Purpose</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {SUB_PROCESSORS.map((sp) => (
              <tr key={sp.name}>
                <td>
                  <strong>{sp.name}</strong>
                </td>
                <td>{sp.purpose}</td>
                <td>{sp.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p>
        Questions about our sub-processors can be directed to{' '}
        <a href={`mailto:${COMPANY.privacyEmail}`}>{COMPANY.privacyEmail}</a>.
      </p>
    </LegalLayout>
  );
}
